import tmhRequest from '@/config/tmhRequest'

export default {
  searchContract: function (data) {
    return tmhRequest({
      url: '/project/tmh/contract/searchcontract',
      method: 'post',
      params: data,
    })
  },

  searchListContract: function (data) {
    return tmhRequest({
      url: '/project/tmh/contract/searchlistcontract',
      method: 'post',
      params: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/contract.js